import { render } from "./Service.vue?vue&type=template&id=07b63399"
import script from "./Service.vue?vue&type=script&lang=js"
export * from "./Service.vue?vue&type=script&lang=js"
script.render = render

export default script